import { View } from "react-native";
import { GestureDetector } from "react-native-gesture-handler";
import RecapAssetShareVariant from "src/api/graphql/__generated__/enums/RecapAssetShareVariant";
import { RecapScreenFragmentFragment } from "src/api/graphql/__generated__/graphql";
import useRecapGesture from "../../hooks/useRecapGesture";
import { RecapScreenContentGenericProps } from "../../types";
import RecapAssetShareContent from "../RecapAssetShareContent/RecapAssetShareContent";
import RecapSubtitleContent from "../RecapSubtitleContent";
import RecapUrlShareContent from "../RecapUrlShareContent";
import RecapVideoContentVideo from "./components/RecapVideoContentVideo";

const RecapVideoContent = ({
	video,
	contentAreaWidth,
	onSelectionChange,
	trackingIdentifier,
}: {
	video: NonNullable<RecapScreenFragmentFragment["video"]>;
} & RecapScreenContentGenericProps) => {
	const gesture = useRecapGesture({ contentAreaWidth, onSelectionChange });

	return (
		<View
			style={{
				alignItems: "center",
				justifyContent: "space-between",
				flex: 1,
			}}
		>
			<GestureDetector gesture={gesture}>
				<View
					style={{
						flex: 1,
						width: "100%",
						alignItems: "center",
					}}
				>
					<RecapSubtitleContent subtitle={video.subtitle} />
					<RecapVideoContentVideo videoUrl={video.videoUrl} />
				</View>
			</GestureDetector>
			{video.shareInfo?.variant === RecapAssetShareVariant.Asset && (
				<RecapAssetShareContent
					variant="Video"
					url={video.shareInfo.url}
					accompanyingAssetShareUrl={video.shareInfo.accompanyingAssetShareUrl}
					trackingIdentifier={trackingIdentifier}
				/>
			)}
			{video.shareInfo?.variant === RecapAssetShareVariant.Url && (
				<RecapUrlShareContent
					url={video.shareInfo.url}
					trackingIdentifier={trackingIdentifier}
				/>
			)}
		</View>
	);
};
export default RecapVideoContent;
